<template>
  <div id="LaborCostView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Labor Cost View</div>
          <div class="web-action-btn btn-groups text-right">
            <router-link title="Edit User"  class="btn btn-primary" v-bind:to="{name: 'LaborCostEdit',params:{id:$route.params.id}}"><i class="fp-edit-icon"> </i> Edit</router-link>
            <router-link class="btn btn-secondary pull-right ml-1" v-bind:to="{name: 'LaborCostList'}" > <i class="fp-back"></i> Back</router-link>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content user-detail list-view">
            <div id="tabs" class="containerTab mt-4">
              <div class="tabs">
                <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">User Details</a>
                <a v-on:click="activityLogs()" v-bind:class="[activetab === 2 ? 'active' : '']">Activity Log</a>
              </div>
              <div class="content">
                <div v-show="activetab === 1" class="tabcontent">
                  <div class="list-sections">
                    <div class="form-row section-divider" style="border-bottom:0px;">
                      <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Type :</label>
                            <span class="col">{{labor_pricing_type}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Cost Code :</label>
                            <span class="col">{{cost_code}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Effective Date :</label>
                            <span class="col">{{effective_date}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Hourly Rate :</label>
                            <span class="col">{{hourly_rate}}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <template v-if="labor_pricing_type == 'Customer Class Override'">
                          <div class="row form-group">
                              <label class="col">Customer Class :</label>
                              <span class="col">{{customer_class}}</span>
                          </div>
                        </template>
                        <template v-if="labor_pricing_type == 'Customer Override' || labor_pricing_type == 'Customer Contract Override'">
                          <div class="row form-group">
                              <label class="col">Customer :</label>
                              <span class="col">{{customer}}</span>
                          </div>
                          </template>
                          <template v-if="labor_pricing_type == 'Customer Contract Override'">
                          <div class="row form-group">
                              <label class="col">Contract Type :</label>
                              <span class="col">{{contract_type}}</span>
                          </div>
                        </template>
                        <template v-if="labor_pricing_type == 'Location Override'">
                        <div class="row form-group">
                            <label class="col">Location :</label>
                            <span class="col">{{location}}</span>
                        </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs">
                    <labor-activity-log-list :activityLogVal="activityLogsTabValue"></labor-activity-log-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
          <div class="error-template">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  
  import {commonMixins} from '../mixins/commonMixins';
  import ActivityLogListView from '@/components/ActivityLogList.vue';
  Vue.component("labor-activity-log-list", ActivityLogListView);
  
  export default {
    name: "LaborCostView",
    mixins:[commonMixins],
    data: () => ({
      permissions: [],
      cantAccessPage: "",
      loading:false,
      activetab: 1,
      activityLogsTabValue: "dontLoadList",
      activityLoaded:false,
      id:"",
      labor_pricing_type:'',
      cost_code:'',
      effective_date:'',
      hourly_rate:'',
      customer:'',
      contract_type:'',
      customer_class:'',
      location:'',

    }),
    watch: {
      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_labor_cost') {
                      self.cantAccessPage = true;
                  }
              }
          }

      }
    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadLaborCostDetails();
        var pathUrl = window.location.pathname;
        var segments = pathUrl.split("/");
        self.id=segments[3];
    },
    metaInfo() {
      return{
              title: "Labor Cost View | " +process.env.COPYRIGHT_NAME
          }
    },
    methods: {
      loadLaborCostDetails() {
        var path = window.location.pathname;
          var segments = path.split("/");
          var self = this;
          self.loading = true;
          $.ajax({
                    url: process.env.ROOT_API + "/labor-cost/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                          self.labor_pricing_type = data.content.type_text;
                          self.cost_code = data.content.cost_code_text;
                          self.effective_date = data.content.formatted_date;
                          self.hourly_rate = data.content.hourly_rate.toFixed(2);
                          if (self.labor_pricing_type == "Customer Override") {

                            self.customer = data.content.custCode + " | " + data.content.custName;
                          } else if (self.labor_pricing_type == "Customer Class Override") {

                            self.customer_class = data.content.custClassCode + " | " + data.content.custClassName;
                          } else if (self.labor_pricing_type == "Customer Contract Override"){

                            self.customer = data.content.custCode + " | " + data.content.custName;
                            self.contract_type = data.content.contTypeCode + " | " + data.content.contTypeName;
                          } else if (self.labor_pricing_type == "Location Override"){

                            self.location = data.content.loc_name + " | " + data.content.loc_code;
                          }
                        }
                    }
           });

      },
      activityLogs(){

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.$root.$emit('activity_log_opted','labor cost',segments[3]);
        self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
        self.activetab = 2;

      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/LaborCostView.vue